export const PassKeyFacts = [
  'You will use device-native biometrics such as Face ID, Touch ID, Windows Hello, or the Android fingerprint reader, but your biometrics never leave your device.',
  'For iPhones and iPads on iOS 16, passkeys are synced via iCloud so you can quickly log in from any device.',
  'On other devices, passkeys are tied to a specific browser and our Passkey provider handles the cross-device connections.',
  'Register and log in in seconds - no passwords to remember or two factor codes to find.',
];
